(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bundle-deal"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function money(cents, format) {
      var amount = (cents / 100).toFixed(2);
      if (format) {
        var token = /\{\{\s*amount[^}]*\}\}/;
        if (token.test(format)) return format.replace(token, amount);
      }
      return '$' + amount;
    }

    function cartDrawerRefresh(root, payload) {
      var addUrl = root.getAttribute('data-add-url');

      // This theme's own cart drawer (dehome-header) is what every other
      // add-to-cart opens. Prefer it. Only fall back to Dawn's <cart-drawer>
      // (drawer cart mode) or the cart page when it isn't present.
      var hasDhDrawer = typeof window.dhOpenCart === 'function';
      var dawnDrawer = document.querySelector('cart-drawer');
      var useDawnDrawer = !hasDhDrawer
        && dawnDrawer
        && typeof dawnDrawer.renderContents === 'function'
        && typeof dawnDrawer.getSectionsToRender === 'function';

      if (useDawnDrawer) {
        payload.sections = dawnDrawer.getSectionsToRender().map(function (s) { return s.id; });
        payload.sections_url = window.location.pathname;
      }

      return fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
        body: JSON.stringify(payload)
      }).then(function (r) { return r.json(); }).then(function (res) {
        if (res.status) { throw new Error(res.description || res.message || 'Nu s-a putut adăuga în coș'); }
        if (hasDhDrawer) {
          // Refreshes /cart.js and slides open the custom drawer.
          window.dhOpenCart();
        } else if (useDawnDrawer) {
          dawnDrawer.renderContents(res);
        } else {
          window.location.href = root.getAttribute('data-cart-url') || '/cart';
        }
      });
    }

    function currentVariantId(root) {
      var picker = document.querySelector('product-info [name="id"]') || document.querySelector('.product-form__input [name="id"]');
      if (picker && picker.value) return picker.value;
      return root.getAttribute('data-default-variant-id');
    }

    function showError(root, msg) {
      var el = root.querySelector('[data-bundle-error]');
      if (!el) return;
      el.textContent = msg;
      el.hidden = false;
    }

    function withBusy(btn, promise) {
      btn.setAttribute('aria-busy', 'true');
      promise.catch(function () {}).then(function () { btn.removeAttribute('aria-busy'); });
    }

    function initTiers(root) {
      var addBtn = root.querySelector('[data-bundle-add]');
      if (!addBtn) return;
      addBtn.addEventListener('click', function () {
        var checked = root.querySelector('[data-tier] input:checked');
        var qty = checked ? parseInt(checked.value, 10) : 1;
        var id = currentVariantId(root);
        if (!id) { showError(root, 'Acest produs este indisponibil.'); return; }
        root.querySelector('[data-bundle-error]').hidden = true;
        withBusy(addBtn, cartDrawerRefresh(root, { id: id, quantity: qty }).catch(function (e) {
          showError(root, e.message);
        }));
      });
    }

    function initByo(root) {
      var items = Array.prototype.slice.call(root.querySelectorAll('[data-bundle-item]'));
      var totalEl = root.querySelector('[data-bundle-total]');
      var sepEl = root.querySelector('[data-bundle-separate]');
      var saveEl = root.querySelector('[data-bundle-savings]');
      var addBtn = root.querySelector('[data-bundle-add]');
      var format = window.Shopify && window.Shopify.money_format;

      var min = parseInt(root.getAttribute('data-byo-min'), 10) || 0;
      var max = parseInt(root.getAttribute('data-byo-max'), 10) || 0;
      var discountPct = parseFloat(root.getAttribute('data-byo-discount')) || 0;

      function recalc() {
        var total = 0, regular = 0, count = 0;
        items.forEach(function (item) {
          var check = item.querySelector('[data-item-check]');
          var q = parseInt(item.getAttribute('data-quantity'), 10) || 1;
          if (check && check.checked) {
            total += (parseInt(item.getAttribute('data-price'), 10) || 0) * q;
            regular += (parseInt(item.getAttribute('data-compare'), 10) || 0) * q;
            count++;
          }
        });

        // Bundle discount (display) applied on top of any compare-at savings.
        var discounted = discountPct > 0 ? Math.round(total * (100 - discountPct) / 100) : total;
        var strike = Math.max(regular, total);
        if (totalEl) totalEl.textContent = money(discounted, format);
        if (strike > discounted) {
          var pct = Math.round(((strike - discounted) / strike) * 100);
          if (sepEl) { sepEl.textContent = money(strike, format); sepEl.hidden = false; }
          if (saveEl) { saveEl.textContent = 'Economisești ' + pct + '%'; saveEl.hidden = false; }
        } else {
          if (sepEl) sepEl.hidden = true;
          if (saveEl) saveEl.hidden = true;
        }

        // Max picking: block further selection once the cap is reached.
        if (max > 0) {
          items.forEach(function (item) {
            var check = item.querySelector('[data-item-check]');
            var required = item.getAttribute('data-required') === 'true';
            if (check && !required && !check.checked) check.disabled = count >= max;
          });
        }

        // Min picking: keep the button locked until enough items are chosen.
        if (addBtn) {
          var ok = count > 0 && (min === 0 || count >= min);
          addBtn.disabled = !ok;
          if (!ok && min > 0) {
            addBtn.setAttribute('data-hint', 'Alege cel puțin ' + min + ' produse');
          } else {
            addBtn.removeAttribute('data-hint');
          }
        }
      }

      items.forEach(function (item) {
        var check = item.querySelector('[data-item-check]');
        if (check) check.addEventListener('change', recalc);
      });
      recalc();

      if (addBtn) {
        addBtn.addEventListener('click', function () {
          var lines = [];
          items.forEach(function (item) {
            var check = item.querySelector('[data-item-check]');
            var q = parseInt(item.getAttribute('data-quantity'), 10) || 1;
            if (check && check.checked) {
              lines.push({ id: item.getAttribute('data-variant-id'), quantity: q });
            }
          });
          if (!lines.length) return;
          root.querySelector('[data-bundle-error]').hidden = true;
          withBusy(addBtn, cartDrawerRefresh(root, { items: lines }).catch(function (e) {
            showError(root, e.message);
          }));
        });
      }
    }

    document.querySelectorAll('[data-bundle]').forEach(function (root) {
      if (root.getAttribute('data-mode') === 'quantity_breaks') initTiers(root);
      else initByo(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dehome-countdown"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    function pad(n) {
      return n < 10 ? '0' + n : String(n);
    }

    function init(root) {
      var deadlineRaw = root.getAttribute('data-deadline');
      var clock = root.querySelector('[data-dh-countdown-clock]');
      var expired = root.querySelector('[data-dh-countdown-expired]');
      var onExpiry = root.getAttribute('data-on-expiry');
      if (!deadlineRaw || !clock) return;

      // Treat a bare "YYYY-MM-DDTHH:MM" as the visitor's local time, which is what a
      // merchant typing a wall-clock deadline expects. Safari needs the seconds.
      var normalized = deadlineRaw.trim().replace(' ', 'T');
      if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/.test(normalized)) normalized += ':00';
      var target = new Date(normalized).getTime();
      if (isNaN(target)) return;

      var nums = {
        days: root.querySelector('[data-dh-unit="days"]'),
        hours: root.querySelector('[data-dh-unit="hours"]'),
        minutes: root.querySelector('[data-dh-unit="minutes"]'),
        seconds: root.querySelector('[data-dh-unit="seconds"]')
      };

      var timer = null;

      function finish() {
        if (timer) clearInterval(timer);
        if (onExpiry === 'hide') {
          root.hidden = true;
          return;
        }
        clock.hidden = true;
        if (expired) expired.hidden = false;
      }

      function tick() {
        var diff = target - Date.now();
        if (diff <= 0) {
          finish();
          return;
        }
        var s = Math.floor(diff / 1000);
        var d = Math.floor(s / 86400);
        var h = Math.floor((s % 86400) / 3600);
        var m = Math.floor((s % 3600) / 60);
        var sec = s % 60;
        if (nums.days) nums.days.textContent = String(d);
        if (nums.hours) nums.hours.textContent = pad(h);
        if (nums.minutes) nums.minutes.textContent = pad(m);
        if (nums.seconds) nums.seconds.textContent = pad(sec);
      }

      tick();
      timer = setInterval(tick, 1000);
    }

    function initAll() {
      document.querySelectorAll('[data-dh-countdown]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    // Theme editor re-renders sections without a page load.
    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target.querySelector('[data-dh-countdown]');
      if (root) init(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
